export const RETRIEVE_GOOGLE_CALENDAR_EVENTS    = "RETRIEVE_GOOGLE_CALENDAR_EVENTS";
export const CHANGE_RESERVATION_VIEW            = "CHANGE_RESERVATION_VIEW";

export const EQUIPMENT_LIST                     = "EQUIPMENT_LIST";
export const EQUIPMENT_TYPE_LIST                = "EQUIPMENT_TYPE_LIST";
